import axios from "axios";

const requestAddressSearch = parameter => {
  //const kakaoLocalAddressSearchUrl = process.env.KAKAO_LOCAL_ADDRESS_SEARCH_URL
  //const kakaoLocalAddressSearchAccessToken = process.env.KAKAO_ACCESS_TOKEN

  const kakaoLocalAddressSearchUrl =
    "https://dapi.kakao.com/v2/local/search/keyword.json";
  const kakaoLocalAddressSearchAccessToken = `KakaoAK ${process.env.VUE_APP_KAKAO_API_KEY} `;

  return fetch(
    `${kakaoLocalAddressSearchUrl}?page=1&size=15&query=${encodeURIComponent(
      parameter
    )}`,
    {
      method: "get",
      headers: { Authorization: kakaoLocalAddressSearchAccessToken }
    }
  )
    .then(res => res.json())
    .then(data => data);
};

function requestAddressSearchPostCode(parameter) {
  const kakaoLocalAddressSearchUrl =
    "https://dapi.kakao.com/v2/local/geo/coord2address.json";
  const kakaoLocalAddressSearchAccessToken =
    "KakaoAK dad84450d0b9170e85df389b6f975410";
  return axios({
    method: "get",
    url: `${kakaoLocalAddressSearchUrl}?x=${parameter.x}&y=${parameter.y}&input_coord=WGS84`,
    headers: { Authorization: `${kakaoLocalAddressSearchAccessToken}` }
  });
}

const requestFuneralAddressSearch = parameter => {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/address/list?address=${parameter}`
  );
};

export {
  requestAddressSearch,
  requestFuneralAddressSearch,
  requestAddressSearchPostCode
};
